import React from 'react';
import { integrations } from '../../mock/content';

// Duplicate the list twice so the marquee scrolls seamlessly
const LOOP = [...integrations, ...integrations];

const IntegrationsMarquee = () => {
  return (
    <section className="bg-white py-16 md:py-20 overflow-hidden">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-10">
          <p className="text-brand-blue text-[12px] font-bold tracking-[0.16em] uppercase mb-3">
            Integrations
          </p>
          <h2 className="text-navy font-black tracking-[-0.01em] leading-[1.15] text-[26px] sm:text-[32px] md:text-[36px]">
            Plugs into the stack your team already runs
          </h2>
          <p className="mt-4 text-body-muted text-[15px] leading-[1.7]">
            Every clean lead lands directly in your client’s CRM, MAP or automation tool — no CSVs, no manual routing, no delay.
          </p>
        </div>
      </div>

      <div className="relative">
        {/* Fade edges */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 z-10 bg-gradient-to-r from-white to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 z-10 bg-gradient-to-l from-white to-transparent" />

        <div className="flex marquee-track">
          {LOOP.map((name, idx) => (
            <div
              key={`${name}-${idx}`}
              className="shrink-0 w-[200px] mx-2 h-16 rounded-xl bg-white shadow-mk-sm flex items-center justify-center text-navy font-bold text-[15px] tracking-tight opacity-80 hover:opacity-100 hover:shadow-mk transition-all duration-300"
            >
              {name}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IntegrationsMarquee;
